export interface KeyInsight {
  id: number;
  title: string;
  description: string;
  reportMonth: string;
  market: {
    id: number;
    name: string;
  };
}

export interface KeyInsightsResponse {
  insights: KeyInsight[];
}

export interface UseKeyInsightsParams {
  marketId?: number;
  continentId?: number;
  countryId?: number;
  limit?: number;
}

interface UseKeyInsightsOptions {
  apiUrl: string;
  authenticatedFetch: (url: string, options?: any) => Promise<Response | null>;
}

export function createKeyInsightsQueryConfig({ apiUrl, authenticatedFetch }: UseKeyInsightsOptions) {
  return {
    getKeyInsights: ({ marketId, continentId, countryId, limit = 3 }: UseKeyInsightsParams) => ({
      queryKey: ['keyInsights', { marketId, continentId, countryId, limit }],
      queryFn: async () => {
        const params = new URLSearchParams();
        if (marketId) params.append('marketId', marketId.toString());
        if (continentId) params.append('continentId', continentId.toString());
        if (countryId) params.append('countryId', countryId.toString());
        params.append('limit', limit.toString());

        const response = await authenticatedFetch(
          `${apiUrl}/api/marketcompass/key-insights?${params.toString()}`
        );
        
        if (!response) {
          throw new Error('Failed to fetch key insights');
        }
        
        if (!response.ok) {
          throw new Error(`Failed to fetch key insights: ${response.statusText}`);
        }
        
        const data = await response.json();
        return data;
      },
      staleTime: 0, // No caching
      gcTime: 0, // No caching
      enabled: !!(marketId || continentId || countryId)
    })
  };
}